class LanguageSyncManager {
  constructor() {
    this.channel = null;
    this.listeners = new Set();
    this.initChannel();
  }

  initChannel() {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel('emotii-language-sync');
      
      this.channel.onmessage = (event) => {
        if (event.data.type === 'language-changed') {
          this.listeners.forEach(callback => {
            try {
              callback(event.data.language);
            } catch (error) {
              console.error('Error in language sync callback:', error);
            }
          });
        }
      };
    }
  }

  notifyLanguageChanged(language) {
    if (this.channel) {
      this.channel.postMessage({
        type: 'language-changed',
        language: language,
        timestamp: Date.now()
      });
    }
  }

  onLanguageChanged(callback) {
    if (typeof callback === 'function') {
      this.listeners.add(callback);
    }
    
    return () => {
      this.listeners.delete(callback);
    };
  }

  destroy() {
    if (this.channel) {
      this.channel.close();
    }
    this.listeners.clear();
  }
}
const languageSyncManager = new LanguageSyncManager();

export default languageSyncManager;